import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'isFutureDate' })
export class FutureDatePipe implements PipeTransform {
  transform(value: any): boolean {
    if (!value) return false;
    
    const date = (value instanceof DateTime) ? value : DateTime.fromISO(value);
    const now = DateTime.now().endOf('day');
    return date >= now;
  }
}